<template>
  <div>
    <v-layout wrap row justify-start pa-2>
      <v-flex xs12 md6 px-2 pb-2>
        <v-card class="elevation-24">
          <v-card-title :class="`headline white--text primary`">
            SALASA
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="loading" :loading="loading" @click="salasaPanel=!salasaPanel">toggle</v-btn>
          </v-card-title>
          <v-card-actions>
            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
            <v-btn color="primary" :disabled="loading" :loading="loading" text @click="loadData()">load</v-btn>
            <v-btn color="primary" :disabled="loading" :loading="loading" text @click="loadData(true)">export</v-btn>
          </v-card-actions>
          <v-card-text v-if="salasaPanel">
            <v-layout row wrap>
              
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
import {firebase, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import json2csv from 'json2csv'

export default {
  data(){
    return {
      loading:false,
      oldProducts:[],
      selectedProduct:null,
      salasaPanel:false,
    }
  },
  methods:{
    async loadData(exp){
      this.loading = true
      let c = await db.ref(`salasa`).once('value').then(x=>x.val())
      console.log(c)
      let dk = Object.keys(c)
      let d = [].concat(
        ...Object.values(c).map((x, i)=>{
          let onk = Object.keys(x)
          return Object.values(x).map((x,k)=>{
            return{...x[Object.keys(x)[Object.keys(x).length-1]], type:dk[i], transaction_key:onk[k]}
          })
        }))
      let g = d.map(x=>x.id)

      console.log(g)
      console.log(d)
      let ex = [];
      d.forEach(n=>{
        if(n.items){
          n.items.forEach(item=>{
            if(item.quantity_good == '0' && item.quantity_hurt == '0') {
              let c = n.customer ? n.customer : {}
              let o = n.order ? n.order : {}
              let status = n.status ? n.status.description : {}
              // delete n.items
              // delete n.customer
              // delete n.order
              // delete n.status
              let f ={
                ...n,
                ...o,
                status,
                ...item,
              }
              ex.push(f)
            }
          })
        } else {
          let c = n.customer ? n.customer : {}
          let o = n.order ? n.order : {}
          let status = n.status ? n.status.description : {}
          // delete n.customer
          // delete n.order
          // delete n.status
          let f ={
            ...n,
            ...o,
            status,
          }
          ex.push(f)
        }
        
      })
      console.log(ex)
      if(exp) {
        this.exportData(ex, 'salasa')
      }
      this.loading = false
    },
    exportData(data, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'leads_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    
  },
  async created(){
    //await db.ref('salasa').update({SalasaInventoryCorrections:null})
  }
}
</script>

<style>

</style>